
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'editor/KeyboardShortcuts';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <li>\n      <code>";
  if (helper = helpers.key) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.key); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</code>\n      <span>";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n    </li>\n  ";
  return buffer;
  }

  buffer += "<ul class=\"tinymce-keyboard-shortcuts\">\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.keybindings), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</ul>\n";
  return buffer;
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/editor/KeyboardShortcuts', {"new_styles_normal_contrast":{"combinedChecksum":"f4493af988"},"new_styles_high_contrast":{"combinedChecksum":"f4493af988"},"responsive_layout_normal_contrast":{"combinedChecksum":"f4493af988"},"responsive_layout_high_contrast":{"combinedChecksum":"f4493af988"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"9b568bbcaf"},"new_styles_high_contrast_rtl":{"combinedChecksum":"9b568bbcaf"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"9b568bbcaf"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"9b568bbcaf"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  